import React, { useCallback } from 'react';
import MetadataTag from '@/shared/crisp/MetadataTag';
import Div from '@/shared/Div';
import Map from '@/components/Map';
import date from '@/utils/date';
import Image from '@/shared/Image';
import Paragraph from '@/shared/Paragraph';
import Link from 'next/link';
import { getBlogURL } from '@/utils/urls';
import Logo from '../Icons/Logo';
Logo;
interface BlogCardProps {
  title: string;
  tags?: any;
  media: any;
  publishedAt: any;
  blogId: string;
}

const BlogCard = (props: BlogCardProps) => {
  const { title, tags, publishedAt, blogId, media } = props;

  const renderTags = useCallback(
    (Tag: any) => (
      <MetadataTag className="!uppercase !text-white !border-none" key={Tag.label} {...Tag} />
    ),
    [],
  );

  const href = getBlogURL(blogId);

  const renderImage = () => {
    if (media?.url) {
      return (
        <Image
          src={media.url}
          alt={media.alternativeText || title}
          className="w-full h-37 md:h-40 object-cover object-center rounded-t-2xl"
        />
      );
    }

    // Custom gradient background using the blue colors from config
    return (
      <Div className="w-full h-37 md:h-40 rounded-t-2xl flex items-center justify-center bg-blog-card-gradient">
        <Logo />
      </Div>
    );
  };

  return (
    <Div className="flex flex-col font-primary">
      <Link href={href}>{renderImage()}</Link>

      <Div className="p-s6 bg-slate-100 rounded-b-2xl h-full flex flex-col">
        <Link href={href}>
          <Paragraph className="text-left text-h-3 md:text-hd-3 mb-s4 flex-grow pb-s6">
            {title}
          </Paragraph>
        </Link>

        <Div className="mt-auto flex flex-row justify-between items-end">
          <Map className="flex items-start gap-2 flex-wrap" list={tags} render={renderTags} />
          <Paragraph className="pt-s2 uppercase text-body-xs md:text-body-xs-desktop whitespace-nowrap">
            {date
              .format(publishedAt, {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              })
              .replaceAll(' ', '-')}
          </Paragraph>
        </Div>
      </Div>
    </Div>
  );
};

export default BlogCard;
